import React from "react"
import Drawer, {DrawerProps} from "../../../Drawer"

export const ClubSearch = ({open, onClose, text, children}: DrawerProps) => {
    return (
        <Drawer anchor="left" open={open} onClose={onClose} text={text.drawer} showCloseIcon={false}>
            {children}
        </Drawer>
    )
}

export default ClubSearch
